type AiComponentCompileErrorOptions = ErrorOptions & {
  sourcePath?: string;
  sourceLabel?: string;
  line?: number | null;
  column?: number | null;
};

export class AiComponentCompileError extends Error {
  readonly sourcePath?: string;
  /** The author-facing label of `sourcePath`, e.g. `diagonal://page/42`. */
  readonly sourceLabel?: string;
  readonly line: number | null;
  readonly column: number | null;

  constructor(message: string, options?: AiComponentCompileErrorOptions) {
    super(message, options);
    this.name = 'AiComponentCompileError';
    this.sourcePath = options?.sourcePath;
    this.sourceLabel = options?.sourceLabel;
    this.line = options?.line ?? null;
    this.column = options?.column ?? null;
  }
}
